<template>
  <v-alert
    v-if="alert.visible"
    :color="computedColor"
    :type="alert.type"
    :icon="computedIcon"
    id="alertComponent"
    variant="outlined"
    prominent
    border="start"
    closable
    class="alert-top-right"
    style="z-index: 19999"
    @click:close="dismissAlert"
  >
    {{ $t(alert.message) }}
  </v-alert>
</template>

<script lang="ts">
import { computed, defineComponent, ref, onMounted, onUnmounted } from 'vue'
import eventBus from '../../eventBus'

export const alert = ref({
  visible: false,
  type: '' as AlertType,
  message: ''
})

export enum AlertType {
  Error = 'error',
  Success = 'success',
  Info = 'info',
  Warning = 'warning'
}

export enum AlertColor {
  Red = 'red',
  Green = 'green',
  Blue = 'blue',
  Gray = 'gray',
  Orange = 'orange'
}

export function showAlert(type: AlertType, message: string) {
  eventBus.emit('alert:show', { type, message })
}

export default defineComponent({
  name: 'AlertComponent',
  setup() {
    const computedColor = computed(() => {
      switch (alert.value.type) {
        case AlertType.Success:
          return AlertColor.Green
        case AlertType.Info:
          return AlertColor.Gray
        case AlertType.Warning:
          return AlertColor.Orange
        case AlertType.Error:
          return AlertColor.Red
      }
    })

    const computedIcon = computed(() => {
      switch (alert.value.type) {
        case AlertType.Success:
          return 'mdi-check-circle'
        case AlertType.Info:
          return 'mdi-information'
        case AlertType.Warning:
          return 'mdi-alert'
        case AlertType.Error:
          return 'mdi-alert-circle'
      }
    })

    const dismissAlert = () => {
      alert.value = {
        visible: false,
        type: '' as AlertType,
        message: ''
      }
    }

    onMounted(() => {
      const handleShowAlert = (event) => {
        alert.value = {
          visible: true,
          type: event.type,
          message: event.message
        }

        setTimeout(() => {
          dismissAlert()
        }, 3000)
      }
      eventBus.on('alert:show', handleShowAlert)

      onUnmounted(() => {
        eventBus.off('alert:show', handleShowAlert)
      })
    })

    return {
      alert,
      computedColor,
      computedIcon,
      dismissAlert
    }
  }
})
</script>
